import { hexToRgba } from '../../utils/functions'

// Grayscale / Neutral
export const GRAY_SCALE_0 = '#FFFFFF'
export const GRAY_SCALE_1 = '#f5f5f5'
export const GRAY_SCALE_2 = '#eeeeee'
export const GRAY_SCALE_3 = '#e0e0e0'
export const GRAY_SCALE_4 = '#bdbdbd'
export const GRAY_SCALE_5 = '#9e9e9e'
export const GRAY_SCALE_6 = '#757575'
export const GRAY_SCALE_7 = '#616161'
export const GRAY_SCALE_8 = '#424242'
export const GRAY_SCALE_9 = '#212121'

// Primary / Brand
export const BLUE_BASE = '#092A48'
export const BLUE_LIGHT = '#ECF2F5'
export const GOLDEN_BASE = '#D8B45A'

// White/Black
export const WHITE = '#FFFFFF'
export const DARK_1 = '#000000'

// MUI default color references
export const PRIMARY = '#000000de'
export const SECONDARY = '#0000008a'
export const DISABLED_HINT = '#00000061'
export const HOVER = '#0000000a'
export const SELECTED = '#00000014'
export const DISABLED_BG_FOCUS = '#0000001f'
export const DISABLED = '#00000042'
export const BORDER = '#0000003b'
export const BACKDROP = '#00000080'
export const SNACKBAR = '#323232'

// Status: active states
export const ACTIVE_RATING = '#ffb400'
export const ACTIVE_LOVING = '#FF6D75'
export const KNOB_INACTIVEKNOB = '#fafafa'

// Text
export const TEXT_DARK = '#0D3C61'
export const MAIN = '#2196f3'
export const DARK = '#0b79d0'
export const LIGHT = '#64b6f7'
export const LIGHT_BG = '#E9F5FE'

// Success
export const SUCCESS_MAIN = '#4caf50'
export const SUCCESS_DARK = '#3b873e'
export const SUCCESS_LIGHT = '#7bc67e'
export const SUCCESS_LIGHT_BG = '#EDF7ED'

// Error
export const ERROR_TEXT_DARK = '#621B16'
export const ERROR_MAIN = '#f44336'
export const ERROR_DARK = '#e31b0c'
export const ERROR_LIGHT = '#f88078'
export const ERROR_LIGHT_BG = '#FEECEB'

// Warning
export const WARNING_TEXT_DARK = '#663D00'
export const WARNING_MAIN = '#ff9800'
export const WARNING_DARK = '#c77700'
export const WARNING_LIGHT = '#ffb547'
export const WARNING_LIGHT_BG = '#FFF5E5'

// Grey A* references
export const GREY_A100 = '#d5d5d5'
export const GREY_A200 = '#aaaaaa'
export const GREY_A700 = '#303030'

// Additional
export const LIGHT_NAVY = 'rgb(36, 69, 103)'
export const SECONDARY_BLUE = '#366590'
export const TERTIARY_BLUE = 'rgb(221, 229, 237)'
export const GREEN = '#01ab8e'
export const PINK = '#d91883'
export const NEW_YELLOW = '#ffb81c'
export const BLUE_BASE_OPACITY_40 = hexToRgba(BLUE_BASE, 0.4)
export const ORANGE = '#ff6900'
export const GRAY = '#dde5ed'
export const PURPLE = '#8216ef'
export const PURPLE_GRADIENT = 'linear-gradient(45deg, rgb(9, 42, 72), rgb(130, 22, 239))'
export const BLUE_GRADIENT = 'linear-gradient(135deg, rgb(9, 42, 72) 0%, rgb(17, 147, 209) 100%)'
export const GREEN_NAVY_GRADIENT = 'linear-gradient(180deg, rgb(0, 171, 142) 0%, rgb(9, 42, 72) 100%)'
export const SUNRISE_GRADIENT = 'linear-gradient(90deg, rgb(225, 184, 28) 0%, rgb(255, 105, 0) 100%)'
export const PINK_PURPLE_GRADIENT = 'radial-gradient(circle at top left, rgb(218, 24, 132), rgb(130, 22, 239))'
export const GRAY_NAVY_GRADIENT = 'linear-gradient(to bottom, rgb(221, 229, 237) 50%, rgb(9, 42, 72) 50%)'
export const TEAL_BLUE_GRADIENT = 'linear-gradient(45deg, rgb(0, 171, 142), rgb(17, 147, 209))'
export const ORANGE_PINK_GRADIENT = 'linear-gradient(to right bottom, rgb(255, 105, 0), rgb(218, 24, 132))'
export const BLUE_GRAY_GRADIENT = 'linear-gradient(to bottom, rgb(221, 229, 237), rgb(166, 187, 200))'
export const PURPLE_NAVY_GRADIENT = 'linear-gradient(45deg, rgb(130, 22, 239), rgb(9, 42, 72))'
export const TEAL_YELLOW_GRADIENT = 'linear-gradient(135deg, rgb(0, 171, 142), rgb(225, 184, 28))'
export const PINK_ORANGE_RADIAL = 'radial-gradient(circle at top right, rgb(218, 24, 132), rgb(255, 105, 0))'
export const GRAY_TEAL_GRADIENT = 'linear-gradient(60deg, rgb(221, 229, 237), rgb(0, 171, 142))'
export const NAVY_ORANGE_GRADIENT = 'linear-gradient(225deg, rgb(9, 42, 72), rgb(255, 105, 0))'
export const GRAY_PURPLE_GRADIENT = 'linear-gradient(to right, rgb(221, 229, 237), rgb(130, 22, 239))'
export const YELLOW_GRAY_GRADIENT = 'linear-gradient(to bottom right, rgb(225, 184, 28), rgb(221, 229, 237))'
export const PINK_BLUE_GRADIENT = 'linear-gradient(135deg, rgb(218, 24, 132), rgb(17, 147, 209))'
export const TEAL_PURPLE_GRADIENT = 'linear-gradient(to right bottom, rgb(0, 171, 142), rgb(130, 22, 239))'
export const NAVY_WHITE_GRADIENT = 'linear-gradient(to bottom, rgb(9, 42, 72), rgb(255, 255, 255))'
export const OCEAN_DEEP_GRADIENT = 'radial-gradient(circle at top center, rgb(9, 42, 72), rgb(0, 171, 142))'
export const AQUA_GRAY_GRADIENT = 'linear-gradient(to bottom, rgb(17, 147, 209), rgb(221, 229, 237))'
export const PURPLE_ORANGE_GRADIENT = 'linear-gradient(45deg, rgb(130, 22, 239), rgb(255, 105, 0))'
export const GRAY_GRADIENT = 'linear-gradient(to right, rgb(221, 229, 237), rgb(166, 187, 200))'
export const YELLOW_TEAL_GRADIENT = 'linear-gradient(to bottom, rgb(225, 184, 28), rgb(0, 171, 142))'
export const BLUE_ORANGE_GRADIENT = 'linear-gradient(135deg, rgb(17, 147, 209), rgb(255, 105, 0))'
export const PURPLE_GRAY_GRADIENT = 'radial-gradient(circle at bottom left, rgb(130, 22, 239), rgb(166, 187, 200))'
export const NAVY_YELLOW_GRAIDENT = 'linear-gradient(to bottom, rgb(9, 42, 72), rgb(225, 184, 28))'
export const PURPLE_BLUE_GRADIENT = 'linear-gradient(110deg, rgb(130, 22, 239), rgb(17, 147, 209))'
export const GRAY_BLUE_GRADIENT = 'linear-gradient(to bottom, rgb(221, 229, 237), rgb(17, 147, 209))'
export const GRAY_WHITE_GRADIENT = 'linear-gradient(to top, rgb(221, 229, 237), rgb(255, 255, 255))'
// Export everything
export default {
  GRAY_SCALE_0,
  GRAY_SCALE_1,
  GRAY_SCALE_2,
  GRAY_SCALE_3,
  GRAY_SCALE_4,
  GRAY_SCALE_5,
  GRAY_SCALE_6,
  GRAY_SCALE_7,
  GRAY_SCALE_8,
  GRAY_SCALE_9,
  BLUE_BASE,
  BLUE_LIGHT,
  WHITE,
  GOLDEN_BASE,
  DARK_1,
  PRIMARY,
  SECONDARY,
  DISABLED_HINT,
  HOVER,
  SELECTED,
  DISABLED_BG_FOCUS,
  DISABLED,
  BORDER,
  BACKDROP,
  SNACKBAR,
  ACTIVE_RATING,
  ACTIVE_LOVING,
  KNOB_INACTIVEKNOB,
  TEXT_DARK,
  MAIN,
  DARK,
  LIGHT,
  LIGHT_BG,
  SUCCESS_MAIN,
  SUCCESS_DARK,
  SUCCESS_LIGHT,
  SUCCESS_LIGHT_BG,
  ERROR_TEXT_DARK,
  ERROR_MAIN,
  ERROR_DARK,
  ERROR_LIGHT,
  ERROR_LIGHT_BG,
  WARNING_TEXT_DARK,
  WARNING_MAIN,
  WARNING_DARK,
  WARNING_LIGHT,
  WARNING_LIGHT_BG,
  GREY_A100,
  GREY_A200,
  GREY_A700,
  SECONDARY_BLUE,
  TERTIARY_BLUE,
  GREEN,
  PINK,
  NEW_YELLOW,
  BLUE_BASE_OPACITY_40,
  ORANGE,
  GRAY,
  PURPLE,
  PURPLE_GRADIENT,
  BLUE_GRADIENT,
  GREEN_NAVY_GRADIENT,
  SUNRISE_GRADIENT,
  PINK_PURPLE_GRADIENT,
  GRAY_NAVY_GRADIENT,
  TEAL_BLUE_GRADIENT,
  ORANGE_PINK_GRADIENT,
  BLUE_GRAY_GRADIENT,
  PURPLE_NAVY_GRADIENT,
  TEAL_YELLOW_GRADIENT,
  PINK_ORANGE_RADIAL,
  GRAY_TEAL_GRADIENT,
  NAVY_ORANGE_GRADIENT,
  GRAY_PURPLE_GRADIENT,
  YELLOW_GRAY_GRADIENT,
  PINK_BLUE_GRADIENT,
  TEAL_PURPLE_GRADIENT,
  NAVY_WHITE_GRADIENT,
  OCEAN_DEEP_GRADIENT,
  AQUA_GRAY_GRADIENT,
  PURPLE_ORANGE_GRADIENT,
  GRAY_GRADIENT,
  YELLOW_TEAL_GRADIENT,
  BLUE_ORANGE_GRADIENT,
  PURPLE_GRAY_GRADIENT,
  NAVY_YELLOW_GRAIDENT,
  PURPLE_BLUE_GRADIENT,
  GRAY_BLUE_GRADIENT,
  GRAY_WHITE_GRADIENT,
}
